const Н = ["H", "𞠡", "𖭜", "𖮍", "𖬩", "𑫞", "𑢥", "𐳢", "𐡲", "𐘰", "𐅒", "ￃ", "Ɦ", "ꛅ", "𐡲", "𐒎", "𐋏", "ꬑ", "ꖾ", "Ԋ", "ዝ", "ዜ", "ዙ"];
const А = ['ꬁ','ꬂ','ꬃ','ꬄ','ꬅ','ꬆ','ꯆ'];
const С = ["C", "𖩀", "𖫜", "𖬜", "𖭖", "𖼔", "𖼕", "𖼐", "𖼑", "𖼒", "𝇋", "𐬪", "𖭖", "𖬜", "𓊆", "𑫐", "𑫖", "𐘳", "𐅁", "𐃗", "𐀲", "ﾧ", "ꛕ", "ꗱ", "ꤍ", "𐒨", "ꗟ", "𐀲"];
const Т = ['𐄼','𐊱','𐍒','𐍢','𐕠','𐕅','𐘄','𐘆','𐘇','𐘝','𐝇','𐠙','𐤷','𐨝',];
const Я = ["Я", "𞢎", "𑆃", "𑆄", "𑀶", "𐛝", "𐚵", "𐜈", "𐙕", "𐌓", "𐙕"];

const charVariantsObject = { Н, А, С, Т, Я };
export { charVariantsObject };